import { useEffect, useState, useRef } from "react";
import { SplashDesign } from "./SplashDesign";
import { api } from "../lib/api";

const CACHE_KEY = "jc_splash_cfg";

export function Splash({ type = "login", onEnd }) {
  const playedRef = useRef(false);
  const [cfg, setCfg] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY)) || null; } catch { return null; }
  });

  useEffect(() => {
    api.get("/branding/splash").then(({ data }) => {
      setCfg(data);
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch { /* ignore */ }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const enabled = cfg ? cfg.sound_enabled !== false : true;
    if (!enabled || playedRef.current) return;
    playedRef.current = true;
    const src = type === "logout" ? "/logout-sfx.mp3" : "/login-sfx.mp3";
    const audio = new Audio(src);
    audio.volume = 0.6;
    audio.play().catch(() => { /* autoplay blocked — ignore */ });
    return () => { audio.pause(); };
  }, [type, cfg]);

  useEffect(() => {
    const t = setTimeout(() => { onEnd && onEnd(); }, 2600);
    return () => clearTimeout(t);
  }, [onEnd]);

  return (
    <div data-testid="splash-overlay" style={{
      position: "fixed", inset: 0, zIndex: 99999, background: "#07030F",
      display: "grid", placeItems: "center", animation: "spl-fade 0.3s ease both",
    }}>
      <SplashDesign cfg={cfg} type={type} />
    </div>
  );
}
